import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  signal,
  untracked,
} from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { HtmlToPlainTextPipe } from '../../pipes/html-to-plain-text.pipe';
import { AddressBaseUi } from '../../../../../shared/models/address.model';
import {
  CopyButtonMode,
  MailingAddressComponent,
} from '../../../../../shared/components/mailing-address/mailing-address.component';

@Component({
  selector: 'ri-resolution-ui-summary-panel',
  imports: [
    MatButtonModule,
    MatExpansionModule,
    HtmlToPlainTextPipe,
    MailingAddressComponent,
  ],
  templateUrl: './summary-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.block]': 'true',
    '[class.h-full]': 'true',
  },
  styles: `
    @starting-style {
      .expanded-panel {
        opacity: 0;
      }
    }
  `,
})
export class SummaryPanelComponent {
  public readonly summary = input<{
    issueCategory: string;
    llmNoteSummary: string;
    opportunitySummary: string;
    facilityAddresses: AddressBaseUi[];
  }>();
  public readonly defaultExpanded = input<boolean>(true);

  private readonly _expanded = signal<boolean>(true);
  public readonly expanded = this._expanded.asReadonly();

  constructor() {
    this.expandPanelOnSummaryInputFieldChange();
  }

  togglePanel(): void {
    this._expanded.update((oldValue) => !oldValue);
  }

  private expandPanelOnSummaryInputFieldChange(): void {
    effect(() => {
      this.summary();
      untracked(() => {
        this._expanded.set(this.defaultExpanded());
      });
    });
  }

  protected readonly CopyButtonMode = CopyButtonMode;
}
